import { claimBonusSkeletonStyles as styles } from "./ClaimBonusSkeletonStyle";
const ClaimBonusSkeleton = ({ count = 3 }) => {
  return (
    <div className={styles.outerContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.skeleton} />
      ))}
    </div>
  );
};

export default ClaimBonusSkeleton;
